"use client";

import config from "configs/app";
import DailyTransactionsChart from "./components/DailyTransactionsChart";
import LatestBlocks from "./components/LatestBlocks";
import LatestSource from "./components/LatestSource";
import LatestTasks from "./components/LatestTasks";
import LatestTransactions from "./components/LatestTransactions";
import StatsGrid from "./components/StatsGrid";
import TaskVolumeChart from "./components/TaskVolumeChart";
import styles from "./Home.module.css";

export default function HomePage() {
  return (
    <main className={styles.container}>
      <StatsGrid />
      <div className={styles.topSection}>
        <div className={styles.leftColumn}>
          <DailyTransactionsChart />
        </div>
        <div className={styles.rightColumn}>
          <TaskVolumeChart />
        </div>
      </div>
      <div className={styles.pageTitleBanner}>
        <div className={styles.pageTitleContent}>
          <h1 className={styles.pageTitle}>{ config.chain.name } Explorer</h1>
        </div>
        <img
          src="/assets/banner-logo.png"
          alt="Banner Logo"
          className={styles.bannerLogo}
        />
      </div>
      <div className={styles.grid}>
        <LatestBlocks />
        <LatestSource />
      </div>
      <div className={styles.gridWithDivider}>
        <LatestTransactions />
        <LatestTasks />
      </div>
    </main>
  );
}
